import { registerDecorator, type ValidationOptions } from 'class-validator';
import { integer } from '@/common/utils';

const BUSINESS_NUMBER_REGEX_LIST = [/^\d{3}-\d{2}-\d{5}$/g, /^\d{10}$/];
const VALIDATION_COEFFICIENT = [1, 3, 7, 1, 3, 7, 1, 3, 5];

export const IsBusinessNumber = (options?: ValidationOptions) => {
  return (object: object, property_name: string) => {
    registerDecorator({
      name: 'isBusinessNumber',
      target: object.constructor,
      propertyName: property_name,
      constraints: [],
      options,
      validator: {
        validate(value: any) {
          if (typeof value !== 'string' || !BUSINESS_NUMBER_REGEX_LIST.some((regex) => regex.test(value))) {
            return false;
          }

          const numbers = value.replace(/-/g, '').split('').map(Number);
          const checksum = createCheckSum(numbers);
          return numbers[numbers.length - 1] === checksum;
        },
        defaultMessage() {
          return 'invalid business number';
        },
      },
    });
  };
};

const createCheckSum = (business_number: number[]) => {
  const checksum = VALIDATION_COEFFICIENT.reduce((acc, coefficient, index) => {
    let value = coefficient * business_number[index];
    if (index === VALIDATION_COEFFICIENT.length - 1) {
      value += integer((coefficient * business_number[index]) / 10);
    }
    return acc + value;
  }, 0);
  return 10 - (checksum % 10);
};
